import { render } from 'hono/jsx/dom';
import './styles/main.css';
import { App } from './App';
import { bootstrapTheme } from './lib/theme';
import { captureRefFromUrl } from './lib/referral';

bootstrapTheme();
// Persist any ?ref= affiliate code before the router strips/ignores it.
captureRefFromUrl();

const root = document.getElementById('root');
if (!root) throw new Error('#root element missing from index.html');
render(<App />, root);
